import { createApiClient } from '@svetoch/api-client';

export const api = createApiClient({ baseUrl: import.meta.env.VITE_API_BASE_URL || '/api/v1' });
export const formatNumber = (value: number) => new Intl.NumberFormat('ru-RU').format(value);
export const materialLabels = { book: 'Книга', map: 'Карта', journal: 'Журнал', other: 'Другое' } as const;
export const errorMessage = (error: unknown) => error instanceof Error ? error.message : 'Не удалось выполнить действие. Попробуйте ещё раз.';
